import * as $ from './APIs'
import { getOrderHistoryList, getOrderHistoryCurrency, getOrderHistoryDetails, getOrderHistoryByBAID } from './APIs/APIOrderHistory'
import { 
    getProductSource, 
    getProductSourceV2, 
    getWarehousesItems, 
    getRemoteWarehouseSelected,
    setRemoteWarehouseSelected,
} from './APIs/APIProductSource'
import { getCashCoupon, getCashCouponQuota, getARBalance, getAllowARBalance, payWithBalance } from './APIs/APIBalance'
import { getFooter, getOnlineCountry } from './APIs/APIFooter'
import { sendFeedback, validateEnrollSponser } from './APIs/APICommon'
import { getRemoteStorage, setRemoteStorage, deleteRemoteStorage, getRemoteNotification, setRemoteNotification, deleteRemoteNotification } from './APIs/APIRemoteStorage'
import { getSamedayDelivery } from './APIs/APIShipping'
import { getHomeBanner } from './APIs/APIHome'

/** **Raven** 🐦 is a promise based HTTP client base on `AJAX`. 
 * Officialy use to connect with **Ushop** APIs. */
class StoreRaven {

    get get() { return $._get }
    get post() { return $._post }
    get update() { return $._update }
    get delete() { return $._delete }

    get getRS() { return getRemoteStorage }
    get setRS() { return setRemoteStorage }
    get delRS() { return deleteRemoteStorage }
    get getRemoteStorage() { return getRemoteStorage }
    get setRemoteStorage() { return setRemoteStorage }
    get deleteRemoteStorage() { return deleteRemoteStorage }
    get getRemoteNotification() { return getRemoteNotification }
    get setRemoteNotification() { return setRemoteNotification }
    get deleteRemoteNotification() { return deleteRemoteNotification }

    get hydraURL() { return $._getHydraEndpoint }
    get switchHydraEndpoint() { return $._switchHydraEndpoint }

    get getFooter() { return getFooter }
    get getOnlineCountry() { return getOnlineCountry }

    /** Get translation JSON of specified languages. 
     * @param {string|array} languages could be **array** or **string** separated with comma (with case insensitive).
     * @example 
     * Raven.getTranslations('EN,TH') 
     * Raven.getTranslations(['EN','TH']) */
    get getTranslations() { return $._getTranslations }
    /** Request server for calculation of single order. Return its price, 
     * availability of items and usually handle any unattended errors of order data. */
    get getOrderCalc() { return $._getOrderCalc }
    get getCommissionPeriod() { return $._getCommissionPeriod }
    get getValidateCart() { return $._getValidateCart }
    get getCheckStockCart() { return $._getCheckStockCart }
    get getSplitAddress() { return $._getSplitAddress }
    // * Balance Features
    get getARBalance() { return getARBalance }
    get getAllowARBalance() { return getAllowARBalance }
    get getCashCoupon() { return getCashCoupon }
    get getCashCouponQuota() { return getCashCouponQuota }
    // * Validation
    /** Request an **Address** data validation result. */
    get validateAddress() { return $._validateAddress }
    /** Request an **Aramex** data validation result. */
    get validateAramex() { return $._validateAramex }
    // * Payment
    /** Request a direct payment process by **ARBalance** credit. 
     * @param {string} referenceID a specified reference id for request order. */
    get payWithBalance() { return payWithBalance }
    // * Authorization
    get login() { return $._login }
    get getCustomer() { return $._getCustomer }
    get getCustomerOnselfProfile() { return $._getCustomerOnselfProfile }
    // * Address History
    get getAddressHistory() { return $._getAddressHistory }
    get addAddressHistory() { return $._addAddressHistory }
    // * Zip Search
    get getZipSearch() { return $._getZipSearch }

    get getMotorZipSearch() { return $._getMotorZipSearch }

    // * search address etc. parent
    get getAddSearchParent() { return $._getAddSearchParent }
    get getAddSearchParentV2() { return $._getAddSearchParentV2 }
    get getCitySearch() { return $._getCitySearch }
    get getCustomerExpand() { return $._getCustomerExpand }

    get getCartInfo() { return $._getCartInfo }
    get addCartInfo() { return $._addCartInfo }

    // * Order History Details
    get getOrderHistoryList() { return getOrderHistoryList }
    get getOrderHistoryCurrency() { return getOrderHistoryCurrency }
    get getOrderHistoryDetails() { return getOrderHistoryDetails }
    get getOrderHistoryByBAID() { return getOrderHistoryByBAID }

    // * Product Source
    get getProductSource() { return getProductSource }
    get getProductSourceV2() { return getProductSourceV2 }
    get getWarehousesItems() { return getWarehousesItems }
    get getRemoteWarehouseSelected() { return getRemoteWarehouseSelected }
    get setRemoteWarehouseSelected() { return setRemoteWarehouseSelected }

    // home page 
    get getHomePageData() { return $._getHomePageData }
    get getHomeBanner() { return getHomeBanner }

    get getBankBook() { return $._getBankBook }
    get getMenuPublic() { return $._getMenuPublic }
    get getMenuWithLogin() { return $._getMenuWithLogin }

    get getPaymentData() { return $._getPaymentData }

    // * Common APIs
    get sendFeedback() { return sendFeedback }

    // * seminars page
    get getSeminarsData() { return $._getSeminarsData }

    // * Shipping Methods
    get getSamedayDelivery() { return getSamedayDelivery }

    get getShortURL() { return $._getShortURL }
    get getShareOptions() { return $._getShareOptions }

    get validateEnrollSponser() { return validateEnrollSponser }
}

const Raven = new StoreRaven()
export default Raven